
import { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";

// Array of interesting armpit facts
const allArmpitFacts = [
  "The average person has around 2 million sweat glands throughout their body, with a high concentration in the armpits.",
  "Your armpits contain two types of sweat glands: eccrine glands that produce odorless sweat and apocrine glands that produce protein-rich sweat that bacteria love.",
  "The medical term for armpit is 'axilla,' derived from Latin.",
  "Armpit hair helps reduce friction between the upper arm and torso during movement.",
  "The smell associated with armpits isn't from sweat itself, but from bacteria breaking down proteins in your sweat.",
  "Some people have a gene that causes them to produce little to no armpit odor.",
  "Many mammals have specialized scent glands in their armpits for communication and marking territory.",
  "The average armpit hosts over 50 species of bacteria.",
  "Armpit lymph nodes play a crucial role in your immune system by filtering harmful substances.",
  "Antiperspirants work by temporarily blocking sweat ducts with aluminum compounds.",
  "Yellow armpit stains on shirts are actually caused by a reaction between sweat proteins and antiperspirant ingredients.",
  "The temperature in your armpit is one of the most accurate places to take a body temperature reading.",
  "Some cultures throughout history have considered armpit odor to be attractive and a sign of fertility.",
  "Shaving your armpits can actually increase odor temporarily as it can irritate the skin and create tiny cuts.",
  "Hyperhidrosis is a condition that causes excessive sweating in the armpits and affects about 3% of the population."
];

// Function to get random facts without repeating until all facts are used
const getRandomFacts = (count: number) => {
  // Make a copy of the facts array to shuffle
  const shuffled = [...allArmpitFacts].sort(() => 0.5 - Math.random());
  // Return the specified number of facts or all if count is larger
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

const DidYouKnowBox = () => {
  // Get 10 random facts on component mount (page load)
  const [facts, setFacts] = useState<string[]>(() => getRandomFacts(10));
  const [currentFactIndex, setCurrentFactIndex] = useState(0);

  useEffect(() => {
    // Change fact every 9 seconds
    const factInterval = setInterval(() => {
      setCurrentFactIndex((prevIndex) => (prevIndex + 1) % facts.length);
    }, 9000); // Change fact every 9 seconds

    // Clean up interval on component unmount
    return () => {
      clearInterval(factInterval);
    };
  }, [facts.length]);

  return (
    <div className="my-10 max-w-3xl mx-auto">
      <Card className="bg-primary/5 hover-card">
        <CardContent className="p-6">
          <div className="flex flex-col items-center">
            <h3 className="text-lg font-bold mb-3 text-center">Did You Know?</h3>
            <p className="text-muted-foreground animate-fade-in text-center mb-4">
              {facts[currentFactIndex]}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DidYouKnowBox;
